import React, { useMemo, useState } from 'react';
import { EmptyState, ScrollArea, SearchInput } from '@onward-delivery/design';
import ProductRow from './ProductRow';
import { draftKey, filterSkus } from './utils';

const ProductList = ({ rows, loading, error, draft, mode, onAdd, onQtyChange, carrierId, needsCarrier }) => {
    const [search, setSearch] = useState('');

    const visible = useMemo(
        () => filterSkus(rows, { search, carrierId: carrierId || null }),
        [rows, search, carrierId]
    );

    return (
        // The rule between the panels is what separates them now that both are
        // white, so it belongs to the left panel's edge rather than a tint.
        <div className="flex w-[536px] shrink-0 flex-col gap-4 border-r border-border pt-6">
            <div className="px-6">
                <SearchInput
                    className="w-full"
                    placeholder="Search SKU, item, or carrier..."
                    onValueChange={setSearch}
                />
            </div>
            <ScrollArea className="min-h-0 flex-1">
                {needsCarrier ? (
                    <EmptyState
                        title="Select a carrier"
                        description="Choose which carrier's stock this order draws from."
                    />
                ) : error ? (
                    <EmptyState title="Couldn't load sellable stock" description="Try again in a moment." />
                ) : !loading && visible.length === 0 ? (
                    <EmptyState title="No sellable stock" description="Nothing matches this search." />
                ) : (
                    visible.map((row) => {
                        const key = draftKey(row);
                        return (
                            <ProductRow
                                key={key}
                                row={row}
                                line={draft.get(key)}
                                mode={mode}
                                onAdd={onAdd}
                                onQtyChange={onQtyChange}
                            />
                        );
                    })
                )}
            </ScrollArea>
        </div>
    );
};

export default ProductList;
